// extracted by mini-css-extract-plugin
export var cards = "index-module--cards--ekKNN";
export var imgContent = "index-module--imgContent--q3e-S";
export var inner = "index-module--inner--17BF7";
export var wrapper = "index-module--wrapper--i3mdi";